import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authentication-home',
  templateUrl: './authentication-home.component.html',
  styleUrls: ['./authentication-home.component.sass']
})
export class AuthenticationHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
